import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';


@Injectable()
export class MenuService {

    // private _getMenuList = new Subject();
    // emitMenuList$ = this._getMenuList.asObservable();

    constructor() { }

    // emitUserMenuList(menuList) {
    //     this._getMenuList.next(menuList);
    // };
}
